import type { CreatePaymentBody } from '@/store/expenses-store/transactions/transactions.dto';

type BuildPaymentArgs = {
  amount: string; // raw form input, e.g. "3000.00"
  recipientEmail: string; // SP.contact_info.email
  recipientName?: string;
  category?: string; // category id (the API resolves id or slug)
  description?: string;
  invoice_id?: string;
  successUrl?: string; // where Stripe redirects after payment
  cancelUrl?: string; // where Stripe redirects on cancel
  needApproval?: boolean;
};

export function buildPaymentBody(a: BuildPaymentArgs): CreatePaymentBody {
  return {
    payout_recipient: a.recipientEmail,
    payout_recipient_name: a.recipientName || undefined,
    transaction_category: a.category || undefined,
    amount: Math.round(Number(a.amount) * 100),
    description: a.description || undefined,
    success_url: a.successUrl || undefined,
    cancel_url: a.cancelUrl || undefined,
    invoice_id: a.invoice_id,
    needs_approval: a.needApproval,
  };
}
